(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('appraisal-firm-region', {
            parent: 'entity',
            url: '/appraisal-firm-region?page&sort&search',
            data: {
                authorities: [/^ROLE_(ADMIN|VC|APPRAISER|APPRAISAL).*/gi],
                pageTitle: 'valueconnectApp.appraisalFirmRegion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/appraisal-firm-region/appraisal-firm-regions.html',
                    controller: 'AppraisalFirmRegionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appraisalFirmRegion');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('appraisal-firm-region-detail', {
            parent: 'entity',
            url: '/appraisal-firm-region/{id}',
            data: {
                authorities: [/^ROLE_(ADMIN|VC|APPRAISER|APPRAISAL).*/gi],
                pageTitle: 'valueconnectApp.appraisalFirmRegion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/appraisal-firm-region/appraisal-firm-region-detail.html',
                    controller: 'AppraisalFirmRegionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appraisalFirmRegion');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AppraisalFirmRegion', function($stateParams, AppraisalFirmRegion) {
                    return AppraisalFirmRegion.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('appraisal-firm-region.new', {
            parent: 'appraisal-firm-region',
            url: '/new',
            data: {
                authorities: [/^ROLE_(ADMIN|VC|APPRAISAL).*/gi]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/appraisal-firm-region/appraisal-firm-region-dialog.html',
                    controller: 'AppraisalFirmRegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                disabled: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('appraisal-firm-region', null, { reload: true });
                }, function() {
                    $state.go('appraisal-firm-region');
                });
            }]
        })
        .state('appraisal-firm-region.edit', {
            parent: 'appraisal-firm-region',
            url: '/{id}/edit',
            data: {
                authorities: [/^ROLE_(ADMIN|VC|APPRAISAL).*/gi]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/appraisal-firm-region/appraisal-firm-region-dialog.html',
                    controller: 'AppraisalFirmRegionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppraisalFirmRegion', function(AppraisalFirmRegion) {
                            return AppraisalFirmRegion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('appraisal-firm-region', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('appraisal-firm-region.delete', {
            parent: 'appraisal-firm-region',
            url: '/{id}/delete',
            data: {
                authorities: [/^ROLE_(ADMIN|VC|APPRAISAL).*/gi]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/appraisal-firm-region/appraisal-firm-region-delete-dialog.html',
                    controller: 'AppraisalFirmRegionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AppraisalFirmRegion', function(AppraisalFirmRegion) {
                            return AppraisalFirmRegion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('appraisal-firm-region', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
